import React, { createContext, useState, ReactNode } from 'react';

interface MobileMenuContextProps {
    isMobileMenuOpen: boolean;
    setIsMobileMenuOpen: (value: boolean) => void;
}

export const MobileMenuContext = createContext<MobileMenuContextProps>({
    isMobileMenuOpen: false,
    setIsMobileMenuOpen: () => {},
});

export const MobileMenuProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
    const[isMobileMenuOpen, setIsMobileMenuOpen] = useState<boolean>(false);
    return (
        <MobileMenuContext.Provider value={{ isMobileMenuOpen, setIsMobileMenuOpen}}>
            {children}
        </MobileMenuContext.Provider>
    );
};
